import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { API } from "@/lib/assets";

export default function ClaimPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setError("no_token"); setLoading(false); return; }
    fetch(`${API}/phantom/${token}`)
      .then(r => r.json())
      .then(res => { if (res.ok) setData(res); else setError(res.error || "not_found"); })
      .catch(() => setError("network"))
      .finally(() => setLoading(false));
  }, [token]);

  const fade = (d = 0) => ({ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6, delay: d } });

  if (loading) return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="w-6 h-6 border-2 border-[#E6FF00] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="text-center max-w-sm">
        <p className="text-5xl mb-4">{error === "ALREADY_CLAIMED" ? "✅" : "❌"}</p>
        <h1 className="font-anton text-2xl text-white uppercase mb-2">
          {error === "ALREADY_CLAIMED" ? "Already claimed" : "Link not found"}
        </h1>
        <p className="font-body text-sm text-white/50 mb-8">
          {error === "ALREADY_CLAIMED" ? "This invite has already been used." : "This invite link is invalid or has expired."}
        </p>
        <Link to="/" className="inline-block font-mono-pw text-sm tracking-widest text-black bg-[#E6FF00] px-8 py-3 uppercase">Go to PINWIN</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center px-6 py-16">
      <motion.div {...fade(0)} className="text-center max-w-md w-full">
        <motion.p {...fade(0.1)} className="text-6xl mb-6">👻</motion.p>
        <motion.h1 {...fade(0.2)} className="font-anton text-3xl md:text-4xl text-white uppercase leading-tight mb-3">
          Hey <span className="text-[#E6FF00]">{data.phantom_name}</span>!
        </motion.h1>
        <motion.p {...fade(0.3)} className="font-body text-sm text-white/60 mb-8">
          <span className="text-[#E6FF00]">@{data.created_by}</span> added you to <span className="text-white">{data.squad_name}</span>
        </motion.p>
        <motion.div {...fade(0.4)} className="flex gap-4 justify-center mb-10">
          <div className="border border-white/10 px-6 py-4 text-center">
            <p className="font-anton text-3xl text-[#E6FF00]">{data.pin_count}</p>
            <p className="font-mono-pw text-[10px] text-white/40 tracking-widest uppercase mt-1">Pins waiting</p>
          </div>
          <div className="border border-white/10 px-6 py-4 text-center">
            <p className="font-anton text-3xl text-white">{data.member_count}</p>
            <p className="font-mono-pw text-[10px] text-white/40 tracking-widest uppercase mt-1">Members</p>
          </div>
        </motion.div>
        <motion.div {...fade(0.5)}>
          <a href={`pinwin://claim/${token}`} onClick={() => setTimeout(() => { window.location.href = "https://pinwin.social"; }, 1500)}
            className="block font-mono-pw text-sm tracking-widest text-black bg-[#E6FF00] px-8 py-4 uppercase text-center hover:brightness-110 transition-all">
            Open in PINWIN
          </a>
        </motion.div>
      </motion.div>
    </div>
  );
}
